import { Box, useTheme } from "@mui/material";
import { SparkLineChart } from "@mui/x-charts";
import Loading from "Components/Loading/Loading";
import { ApiMetric } from "@incendium/api";
import { useProductTrendPoints } from "features/products/hooks/useProductTrendPoints";

interface ProductTrendSparklineProps {
  productName: string;
  trendMetric: ApiMetric;
  height?: number;
  loadingSize?: number;
}

function ProductTrendSparkline({
  productName,
  trendMetric,
  height = 48,
  loadingSize = 24,
}: ProductTrendSparklineProps) {
  const theme = useTheme();
  const { trendPoints, loading } = useProductTrendPoints(
    productName,
    trendMetric,
  );
  const showSparkline = !loading && trendPoints.length > 1;

  if (loading) {
    return (
      <Box
        sx={{
          height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loading size={loadingSize} />
      </Box>
    );
  }

  if (!showSparkline) {
    return <Box sx={{ height }} />;
  }

  return (
    <SparkLineChart
      data={trendPoints}
      curve="natural"
      area
      height={height}
      colors={[theme.palette.primary.main]}
      margin={{ top: 4, bottom: 0, left: 0, right: 0 }}
      sx={{
        "& .MuiAreaElement-root": { opacity: 0.35 },
      }}
      yAxis={{
        min: Math.min(...trendPoints),
        max: Math.max(...trendPoints),
      }}
    />
  );
}

export default ProductTrendSparkline;
